module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_9005.e2d1af3c.png";